import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

type Props = {
    onClose: Function,
    branding: {
        paywall_brand_logo: string,
        paywall_secondary_color: string,
    },
    hideLogo: boolean,
};

class Header extends Component<Props> {
    render() {
        let logo;
        if (this.props.branding.paywall_brand_logo && !this.props.hideLogo) {
            logo = this.props.branding.paywall_brand_logo;
        }

        return (
            <Fragment>
                <a id="close" onClick={this.props.onClose}>
                    <i />
                    <i />
                </a>
                <div
                    id="brandheader"
                    style={{
                        background: this.props.branding.paywall_secondary_color,
                    }}
                >
                    {logo ? <img src={logo} /> : null}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        branding: state.branding,
        hideLogo: state.paywall.options.hideLogo,
    };
};

export default connect(
    mapStateToProps,
    {}
)(Header);



// WEBPACK FOOTER //
// ./src/ui/components/Modal/Header/index.js